/**
 * 404 —— 学员端
 * -----------------------------------------------------------------------------
 * 常见成因是**转发了链接**或从旧入口进入。因此这里引导回公众号菜单，
 * 而不是给一个「返回上一页」——转发来的用户根本没有可用的上一页。
 */
import { useNavigate } from 'react-router-dom';
import { AlertIcon } from '../components/icons';
import { EmptyHint, PageShell } from '../components/layout';

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <PageShell>
      {/* 图标用警示而不是铃铛：铃铛在这里会被读成「有消息」，与「链接失效」无关 */}
      <EmptyHint
        icon={<AlertIcon size={34} strokeWidth={1.5} />}
        title="页面不存在或已失效"
        description="请从公众号菜单重新进入，或返回服务台首页"
        actionText="返回服务台"
        onAction={() => navigate('/home')}
        fill
      />
    </PageShell>
  );
}
